/* istanbul ignore file */
import {
  Context,
  useWishlistFactory,
  UseWishlistFactoryParams
} from '@vue-storefront/core';
import type { Wishlist, WishlistItem, Product } from '@bee-hole/api';
import { useApiError } from '../useApiError';

const params: UseWishlistFactoryParams<Wishlist, WishlistItem, Product> = {
  provide: () => ({
    useApiError: useApiError()
  }),
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  load: async (context: Context, params: any) => {
    const res = await context.$xbuy.api.wishList(params);
    // console.log('## 获取心愿单列表同步回执 ##', res);
    if (res.code > 0) {
      context.useApiError.set(res);
      // throw new Error(res.message);
    }
    return res.data;
  },

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  addItem: async (context: Context, { currentWishlist, product }) => {
    const res = await context.$xbuy.api.wishAdd(product);
    context.useApiError.set(res);
    if (res.code > 0) {
      throw new Error(res.message);
    } else {
      return params.load(context, {});
    }
  },

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  removeItem: async (context: Context, { product }) => {
    const res = await context.$xbuy.api.wishDelete(product);
    // console.log('## 心愿单删除商品同步回执 ##', res);
    if (res.code > 0) {
      context.useApiError.set(res);
      throw new Error(res.message);
    } else {
      return params.load(context, {});
    }
  },

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  clear: async (context: Context) => {
    const res = await context.$xbuy.api.wishClear();
    if (res.code > 0) {
      context.useApiError.set(res);
      throw new Error(res.message);
    }
    return res.data;
  },

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  isInWishlist: (context: Context, { currentWishlist, product }) => {
    if (!currentWishlist || !currentWishlist.list) return false;

    const item = currentWishlist.list.find(item => {
      return product.goodId === item.goodId;
    });
    if (item) {
      return true;
    } else {
      return false;
    }
  }
};

export const useWishlist = useWishlistFactory<Wishlist, WishlistItem, Product>(params);
